import React, { Component } from "react"
import { NamespacesConsumer as I18n } from "react-i18next"
import "moment/locale/th"
import Moment from "react-moment"

//component
import Tooltip from "./Tooltip"

//material ui
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import { styles } from "../containers/Style/TooltipStyle"

class TimeAgo extends Component {
	state = {
		arrowRef: null
	}

	handleArrowRef = node => {
		this.setState({
			arrowRef: node
		})
	}
	render() {
		const { classes } = this.props

		return (
			<I18n>
				{t => {
					return (
						<Tooltip
							classes={{ popper: classes.arrowPopper }}
							PopperProps={{
								popperOptions: {
									modifiers: {
										arrow: {
											enabled: Boolean(this.state.arrowRef),
											element: this.state.arrowRef
										}
									}
								}
							}}
							title={
								<React.Fragment>
									<Moment
										style={{
											fontSize: "1.2em",
											fontFamily: "Noto Sans, sans-serif"
										}}
										locale={t("shortcode")}
										element={"span"}
									>
										{this.props.date}
									</Moment>{" "}
									<span className={classes.arrow} ref={this.handleArrowRef} />
								</React.Fragment>
							}
							aria-label="Date"
						>
							<Moment
								locale={t("shortcode")}
								fromNow
								style={{ color: "#595959" }}
							>
								{this.props.date}
							</Moment>
						</Tooltip>
					)
				}}
			</I18n>
		)
	}
}
TimeAgo.propTypes = {
	classes: PropTypes.object.isRequired
}

export default withStyles(styles)(TimeAgo)
